import React from 'react';
import { Element } from 'react-scroll';
import PropTypes from 'prop-types';

const ScrollerElement = ({
  target, name, children, ...otherProps
}) => (
  <Element name={`${target}_${name}`} {...otherProps}>
    {children}
  </Element>
);

ScrollerElement.propTypes = {
  target: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
};

ScrollerElement.defaultProps = {
  children: null,
};

module.exports = ScrollerElement;



// WEBPACK FOOTER //
// ./components/misc/ScrollerElement.js